import { useSelector } from "react-redux";
import useGAEventTracker from "../hooks/useGAEventTracker";
import { events } from "../hooks/config";

const FooterLinks = () => {
  const { category, action, label } = events.socialAccount;
  const GAEventsTracker = useGAEventTracker(category);
  const { footer } = useSelector((state) => state.i18n);
  const {
    footerLinks: { social, policy, isEnabledFooterLink },
  } = useSelector((state) => state.settings);
  const settings = useSelector((state) => state.settings);
  const showSocial = () => {
    let show = false;
    for (let i in social) {
      if (social[i]?.length) {
        show = true;
      }
    }
    return show;
  };

  const showPolicy = () => {
    let show = false;
    for (let i in policy) {
      if (policy[i]?.length) {
        show = true;
      }
    }
    return show;
  };

  if (!isEnabledFooterLink) return null;

  return (
    <div
      className={`omg-footer-link ${
        !!showSocial() && !!showPolicy()
          ? "justify-content-around"
          : "justify-content-center"
      }`}
    >
      {!!showSocial() && (
        <div className="omg-social-media">
          {social?.facebook && social?.facebook?.length !== 0 ? (
            <a
              onClick={() => {
                GAEventsTracker(action, `${label} facebook`);
              }}
              style={{ background: settings.general.mainColor }}
              href={social.facebook}
              className="omg-link"
              target="_blank"
              rel="noreferrer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                viewBox="0 0 24 24"
              >
                <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"></path>
              </svg>
            </a>
          ) : (
            ""
          )}
          {social?.twitter && social?.twitter?.length !== 0 ? (
            <a
              onClick={() => {
                GAEventsTracker(action, `${label} twitter`);
              }}
              style={{ background: settings.general.mainColor }}
              href={social.twitter}
              className="omg-link"
              target="_blank"
              rel="noreferrer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" />
              </svg>
            </a>
          ) : (
            ""
          )}
          {social?.instagram && social?.instagram?.length !== 0 ? (
            <a
              onClick={() => {
                GAEventsTracker(action, `${label} instagram`);
              }}
              style={{ background: settings.general.mainColor }}
              href={social.instagram}
              className="omg-link"
              target="_blank"
              rel="noreferrer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 448 512"
              >
                <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"></path>
              </svg>
            </a>
          ) : (
            ""
          )}
          {social?.tiktok && social?.tiktok?.length !== 0 ? (
            <a
              onClick={() => {
                GAEventsTracker(action, `${label} tiktok`);
              }}
              style={{ background: settings.general.mainColor }}
              href={social.tiktok}
              className="omg-link"
              target="_blank"
              rel="noreferrer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 448 512"
              >
                <path d="M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"></path>
              </svg>
            </a>
          ) : (
            ""
          )}
          {social?.pinterest && social?.pinterest?.length !== 0 ? (
            <a
              onClick={() => {
                GAEventsTracker(action, `${label} pinterest`);
              }}
              style={{ background: settings.general.mainColor }}
              href={social.pinterest}
              className="omg-link"
              target="_blank"
              rel="noreferrer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 448 512"
              >
                <path d="M448 80v352c0 26.5-21.5 48-48 48H154.4c9.8-16.4 22.4-40 27.4-59.3 3-11.5 15.3-58.4 15.3-58.4 8 15.3 31.4 28.2 56.3 28.2 74.1 0 127.4-68.1 127.4-152.7 0-81.1-66.2-141.8-151.4-141.8-106 0-162.2 71.1-162.2 148.6 0 36 19.2 80.8 49.8 95.1 4.7 2.2 7.1 1.2 8.2-3.3.8-3.4 5-20.1 6.8-27.8.6-2.5.3-4.6-1.7-7-10.1-12.3-18.3-34.9-18.3-56 0-54.2 41-106.6 110.9-106.6 60.3 0 102.6 41.1 102.6 99.9 0 66.4-33.5 112.4-77.2 112.4-24.1 0-42.1-19.9-36.4-44.4 6.9-29.2 20.3-60.7 20.3-81.8 0-53-75.5-45.7-75.5 25 0 21.7 7.3 36.5 7.3 36.5-31.4 132.8-36.1 134.5-29.6 192.6l2.2.8H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48z" />
              </svg>
            </a>
          ) : (
            ""
          )}
        </div>
      )}
      {!!showPolicy() && (
        <div className="omg-policy">
          {policy?.privacyPage?.length !== 0 ? (
            <a
              href={policy.privacyPage}
              className="omg-link"
              target="_blank"
              rel="noreferrer"
            >
              {footer.privacyPage}
            </a>
          ) : (
            ""
          )}
          {policy?.returnPage?.length !== 0 ? (
            <a
              href={policy.returnPage}
              className="omg-link"
              target="_blank"
              rel="noreferrer"
            >
              {footer.returnPage}
            </a>
          ) : (
            ""
          )}
          {policy?.support?.length !== 0 ? (
            <a
              href={
                policy.support.indexOf("@") === -1
                  ? policy.support
                  : `mailto: ${policy.support}`
              }
              className="omg-link"
              target="_blank"
              rel="noreferrer"
            >
              {footer.support}
            </a>
          ) : (
            ""
          )}
          {policy?.termPage?.length !== 0 ? (
            <a
              href={policy.termPage}
              className="omg-link"
              target="_blank"
              rel="noreferrer"
            >
              {footer.termPage}
            </a>
          ) : (
            ""
          )}
        </div>
      )}
    </div>
  );
};

export default FooterLinks;
